/**
 * Zweck: Beschreibt class BestellungPreisUndMwstSatz und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bestellung-preis-und-mwst-satz.ts.
 */
export class BestellungPreisUndMwstSatz {
  Preis: number;
  Mehrwertsteuersatz: number;
}
